import {
  EntityAdapter,
  EntityState as ngEntityState,
  createEntityAdapter,
} from "@ngrx/entity";
import { Entity } from "./entity.model";

export const entityAdapter: EntityAdapter<Entity> =
  createEntityAdapter<Entity>();

export interface EntityState extends ngEntityState<Entity> {}

export const initialState: EntityState = entityAdapter
    .getInitialState({});
